import React from 'react';
import { Route, Routes } from 'react-router-dom';
import AppRoutes from './AppRoutes';
import { Layout } from './components/Layout';
import './custom.css';
import AuthService from "./services/auth-service";
import { useDispatch } from 'react-redux';
import { setUser } from './redux/userSlice';

const App = () => {
    const dispatch = useDispatch();
    const onRefresh = async () => { dispatch(setUser(await AuthService.refreshUser())); }
    onRefresh();

    return (
        <Layout>
            <Routes>
                {AppRoutes.map((route, index) => {
                    const { element, ...rest } = route;
                    return <Route key={index} {...rest} element={element} />;
                })}
            </Routes>
        </Layout>
    );
}

export default App;
